import React, { useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Switch,
  InputNumber,
  Radio,
  Select,
} from "antd";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";

const PointsTransactionPopup = ({ show, close, details, totalPoints }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const obj = form.getFieldsValue();
      if (Number(obj.points) > Number(totalPoints)) {
        Notification.error(
          "Points should not be greater than your total points",
        );

        return;
      }
      if (obj.shopId && obj.points && obj.points <= totalPoints) {
        const data = await axios
          .patch("/shop-points-transfer", obj)
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) handleCancel();
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    close();
  };

  return (
    <>
      <Modal
        title={"Transfer Points"}
        open={show}
        onCancel={handleCancel}
        footer={false}
      >
        <Form
          layout={"horizontal"}
          form={form}
          size={"small"}
          labelCol={{
            span: 6,
          }}
          style={{
            marginTop: 30,
          }}
        >
          <Form.Item
            label="Shop Name"
            name="shopId"
            rules={[
              {
                required: true,
                message: "Shop Name is required",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {details.map((i) => (
                <Select.Option key={i.id} value={i.id}>
                  {i.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Points"
            name="points"
            initialValue={totalPoints}
            rules={[
              {
                required: true,
                message: "Points is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
              onClick={handleOk}
            >
              Transfer
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default PointsTransactionPopup;
